import { Directive, forwardRef } from '@angular/core';
import { FormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import * as utils from '@app/shared/utils';

const CNPJ_LENGTH: number = 18;

@Directive({
  selector: '[appCnpj]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CnpjDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class CnpjDirective implements Validator {
  validate(control: FormControl): ValidationErrors | null {
    return CnpjDirective.isValid(control.value);
  }

  static isValid = (value: string): ValidationErrors | null => {
    const sanitize: string = utils.formatCnpj(value);
    if (sanitize.length !== CNPJ_LENGTH) {
      return { error: true };
    }
    return value && utils.validCnpj(value) ? null : { error: true };
  };
}
